import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ModalFooterComponent from "../modal-footer/modal-footer-component";
import { StyledModalWithSignupContentComponent } from "./modal-content-component.scss";
import onClickOutside from "react-onclickoutside";
class ModalWithSignupContentComponent extends PureComponent {
    handleClickOutside() {
        this.props.onCloseModal();
    }
    render() {
        const { children, footerText, onCloseModal, style, withSignup } = this.props;
        return /*#__PURE__*/ _jsxs(StyledModalWithSignupContentComponent, {
            className: "modal-content-wrapper",
            style: {
                minHeight: style.content.minHeight,
                minWidth: style.content.minWidth
            },
            children: [
                children,
                withSignup && /*#__PURE__*/ _jsx("div", {
                    className: "modal-footer-wrapper",
                    children: /*#__PURE__*/ _jsx(ModalFooterComponent, {
                        footerText: footerText
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
}
ModalWithSignupContentComponent.defaultProps = {
    withSignup: true
};
export default onClickOutside(ModalWithSignupContentComponent);
